import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DialogService, User, UserChangeAwareComponent, UserSessionService, PermissionUtils} from '@rbaip/ui-component';
import {ItemAuctionService} from './shared/item-auction.service';
import {ItemAuctionInfo} from './shared/item-auction-info.model';
import {permissionType} from '../shared/permission';
import {ItemSummaryDispatcherService} from '../shared/item-summary-dispatcher.service';
import {ItemBasicInfo} from '../shared/domain/item';

@Component({
  selector: 'lib-asset-listing',
  templateUrl: './asset-listing.component.html'
})
export class AssetListingComponent extends UserChangeAwareComponent implements OnInit, OnDestroy {
  @Input() equipId: number;

  private itemBasicInfo: ItemBasicInfo;
  writable: boolean;
  itemAuctionInfo: ItemAuctionInfo;
  isLoading = true;

  constructor(private dialogService: DialogService,
              private itemAuctionService: ItemAuctionService,
              public userSessionService: UserSessionService,
              private itemSummaryDispatcherService: ItemSummaryDispatcherService) {
    super(userSessionService);
    this.initUserChangeAware();
  }

  ngOnInit(): void {
    this.loadItemBasicInfo();
  }

  ngOnDestroy(): void {
    this.disposeUserChangeAware();
  }

  userSignedIn(user: User): void {
    if (user) {
      this.init();
    }
  }

  userSignedOut(): void {
    this.writable = false;
    this.itemAuctionInfo = null;
  }

  refreshAuctionInfo(): void {
    this.init();
  }

  private loadItemBasicInfo(): void {
    this.itemSummaryDispatcherService.getItemBasicInfoByEquipId(this.equipId)
      .subscribe(itemBasicInfo => {
        this.itemBasicInfo = itemBasicInfo;
        this.init();
        this.isLoading = false;
      });
  }

  private init(): void {
    this.writable = PermissionUtils.hasPermission(this.userSessionService, permissionType.canViewAdminPage) ||
      PermissionUtils.hasPermission(this.userSessionService, permissionType.canViewOnsiteAdminPage) ||
      PermissionUtils.hasPermission(this.userSessionService, permissionType.canViewAssetPackage) ||
      PermissionUtils.hasPermission(this.userSessionService, permissionType.canModifyEquipmentDetails) ||
      PermissionUtils.hasSitePermission(this.userSessionService, permissionType.canModifyEquipmentDetails, this.itemBasicInfo.eventSiteId)
    ;

    if (!this.writable) { return; }

    if (this.equipId !== null && this.equipId !== undefined) {
      this.dialogService.showProgress();
      this.itemAuctionService.getItemAuctionInfo(this.equipId)
        .subscribe(response => {
          this.itemAuctionInfo = response;
          this.dialogService.hideProgress();
        });
    }
  }
}
